import './index.less';
import './index.scss';
import React from 'react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { createRoot } from 'react-dom/client';
import { App } from './app/App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from 'shared/contexts/Auth';
import { SocketContextProvider } from './shared/contexts/SocketContext';

Sentry.init({
	dsn: import.meta.env.SENTRY_DSN,
	integrations: [new Integrations.BrowserTracing()],

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 1.0
});

const rootElement = document.getElementById('root')!;
const root = createRoot(rootElement);
root.render(
	<React.StrictMode>
		<AuthProvider>
			<SocketContextProvider>
				<App />
			</SocketContextProvider>
		</AuthProvider>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
